import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import ListingCard from "@/components/ListingCard";
import ShareButtons from "@/components/ShareButtons";
import { BadgeCheck, Star } from "lucide-react";

export default function DesignerProfile() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/designers/${id}`).then((r) => setData(r.data));
  }, [id]);
  if (!data) return <div className="min-h-[50vh] flex items-center justify-center text-muted-foreground">Loading…</div>;
  const { designer, listings, reviews } = data;
  return (
    <div className="max-w-[1400px] mx-auto px-6 py-10">
      <div className="border border-border rounded-lg bg-slate-950 text-white p-8 relative overflow-hidden">
        <div className="absolute inset-0 mesh-grid opacity-30" />
        <div className="relative flex items-start gap-5">
          <div className="h-20 w-20 rounded-full bg-primary/20 text-primary flex items-center justify-center font-display font-bold text-3xl shrink-0">{designer.name?.[0]}</div>
          <div className="flex-1 min-w-0">
            <h1 className="font-display font-extrabold text-3xl flex items-center gap-2">{designer.name} {designer.verified && <BadgeCheck className="h-6 w-6 text-primary" />}</h1>
            <p className="font-mono text-sm text-slate-300 mt-1 flex items-center gap-1"><Star className="h-4 w-4 fill-amber-400 text-amber-400" /> {designer.rating || "—"} · {designer.rating_count} reviews · {listings.length} files</p>
            {designer.bio && <p className="text-slate-300 mt-3 max-w-2xl text-sm">{designer.bio}</p>}
          </div>
          <div className="shrink-0">
            <ShareButtons type="designer" id={designer.id} title={`${designer.name} — Jewellery CAD Designer`} compact />
          </div>
        </div>
      </div>

      <h2 className="font-display font-bold text-2xl mt-10 mb-5">Design portfolio</h2>
      {listings.length === 0 ? (
        <p className="text-muted-foreground">No published designs yet.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">{listings.map((l) => <ListingCard key={l.id} listing={l} />)}</div>
      )}

      {reviews.length > 0 && (
        <>
          <h2 className="font-display font-bold text-2xl mt-12 mb-5">Buyer reviews</h2>
          <div className="grid md:grid-cols-2 gap-4">
            {reviews.map((r) => (
              <div key={r.id} className="border border-border rounded-md p-4 bg-card">
                <div className="flex items-center justify-between">
                  <span className="font-medium text-sm">{r.buyer_name}</span>
                  <span className="flex text-amber-500">{Array.from({ length: r.rating }).map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-amber-500" />)}</span>
                </div>
                {r.comment && <p className="text-sm text-muted-foreground mt-2">{r.comment}</p>}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
